import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const uploadBill = {
  component: QuestionWrapper,
  componentProps: {
    type: 'uploadBill',
    label: 'Usage',
    formValue: 'billData',
    title: 'What was your energy usage last month?',
    tooltip:
      "Adding last month's bill helps us give you a more precise picture of what you could save.",
    canSkip: true,
    tracking: {
      stepName: 'Bill Upload',
      deepStepNumber: 8,
      quickStepNumber: 8,
      deepStepId: '8',
      quickStepId: '8',
      fieldName: 'one_month_bill_info',
    },
  },
  name: 'uploadBill',
  coreIf: false,
  schema: z.object({
    billData: z.array(
      z
        .object({
          usage: z.number(),
          billing: z.number().nullable().optional(),
          month: z.string().min(1, 'Month is required'),
          year: z.number().min(1, 'Year is required'),
          address: z.string().optional(),
          zipCode: z.string().optional(),
          planName: z.string().optional(),
        })
        .optional(),
    ),
  }),
}
